import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11d6781c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistic" }
const _hoisted_2 = {
  key: 0,
  class: "statistic__title"
}
const _hoisted_3 = {
  key: 1,
  class: "statistic__title"
}

import { PropType } from 'vue'
import {
  StatisticAppointmentType,
  StatisticAppointmentTypeWithPatients,
  StatisticReportType,
} from '@/shared/types'
import IndicatorsStatisticChart from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatisticChart.vue'
import { useUser } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  props: {
  reports: Array as PropType<
    | StatisticReportType[]
    | StatisticAppointmentType[]
    | StatisticAppointmentTypeWithPatients[]
  >,
  onChartClick: Function,
},
  setup(__props) {

// :key="reports" may throw error because key is not a string but it actually triggers chart rerender when reports change
const { user } = useUser()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(user).role === 'doktor')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Ваша статистика (" + _toDisplayString(_unref(user).name) + ") ", 1))
      : _createCommentVNode("", true),
    (_unref(user).role !== 'doktor')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Статистика по клинике "))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(IndicatorsStatisticChart, {
      key: __props.reports,
      "chart-data": __props.reports,
      "on-chart-click": __props.onChartClick
    }, null, 8, ["chart-data", "on-chart-click"]))
  ]))
}
}

})